import { render, staticRenderFns } from "./SpouseInfo.vue?vue&type=template&id=fa182ee2&scoped=true"
import script from "./SpouseInfo.vue?vue&type=script&lang=ts"
export * from "./SpouseInfo.vue?vue&type=script&lang=ts"
import style0 from "./SpouseInfo.vue?vue&type=style&index=0&id=fa182ee2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa182ee2",
  null
  
)

export default component.exports